import React, { useState } from "react";
import { useGetCryptosQuery } from "../services/cryptoApi";
import { Container, Box, Typography, TextField, Grid } from "@mui/material";
import Table from "../components/Table";
import LoadingPage from "../components/LoadingScreen";
import { DatePicker } from "@mui/lab";
import { format } from "date-fns";
import { loadingActions } from "../store/loading-slice";
import { useDispatch } from "react-redux";

const Cryptos = () => {
  const dispatch = useDispatch();
  const [date, setDate] = useState(new Date());

  const formatedDate = () => {
    const givenDate = format(date, "yyyy/MM/dd");

    const readableForApi = givenDate.replaceAll("/", "-");
    return readableForApi;
  };


  

  const { isLoading, isError, data, isFetching,isSuccess } =
    useGetCryptosQuery(formatedDate());

  if (isLoading || isFetching) {
    dispatch(loadingActions.openHandler())
    return <LoadingPage />;
  }

  if(isSuccess){
    dispatch(loadingActions.closeHandler())
  }



  const rows = data?.results?.map(({ T, c, h, l, v }, index) => ({
    id: index,
    exchangeSymbol: T.replace("X:", ""),
    closePrice: c,
    highestPrice: h,
    lowestPrice: l,
    tradingVolume: v,
  }));

  return (
    <Box sx={{ mt: "5rem" }}>
      <Typography variant="h4" align="center">
        Grouped Daily
      </Typography>
      <Container maxWidth='md' sx={{ mt: "1.5rem" }}>
        <Grid container justifyContent="center">
          <Grid item>
            <DatePicker
            disableFuture
              label="Pick a date"
              value={date}
              inputFormat="MM/dd/yyyy"
              onChange={(newValue) => {
                setDate(newValue);
              }}
              renderInput={(params) => <TextField  {...params} />}
            />
          </Grid>
        </Grid>
        <Table rows={rows} />
      </Container>
    </Box>
  );
};

export default Cryptos;
